import React, { Component, useState, useEffect, useRef, createRef } from 'react'
import { connect } from 'react-redux'
import { Table, FormControl, Image, Button, OverlayTrigger, Tooltip, Form, Collapse } from 'react-bootstrap'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment'
import 'moment/locale/de'

import '../../index.css'
import { FetchReadIncomingTransactions, FetchApproveCorrection, FetchReadOutgoingTransactions } from '../../fetcher';
import { getSizeEntries, getSizeNumbers, getCorrectionNumbers, getTotal } from '../presentational-components/TableComponent'
import AlertMessage from '../presentational-components/AlertMessage';
import { ModalComponent } from '../presentational-components/ModalComponent';
import DescriptionTooltip from '../presentational-components/DescriptionTooltip';
import EnumValueTranslations from '../presentational-components/EnumValueTranslations';
import { ExportCSV } from '../presentational-components/ExportCSV';
import { useExpandRows, useSortTransactions } from '../presentational-components/tablehooks';
import { DateSelect, StateSelect, useDateFilter, useFilterTransactions, useSearchFilter, useSelectFilter } from '../presentational-components/filterutils';
import LoadingSpinner from '../presentational-components/LoadingSpinner';


moment.locale('de')

const getColourClassStatus = (status) => {
    //if (status == "InTransit") return "inTransit"
    if (status == "Confirmed") return "approved"
    else if (status == "Inaccurate") return "correction"
    else return "inTransit"
}

const correctionColor = (inaccurateState) => {
    return (inaccurateState == true ? "correction-corrected" : "correction-approved")
}

const TransactionArchive = (transactionType) => {
    const [showAlertMessage, setShowAlert] = useState(false)
    const openAlert = () => {
        setShowAlert(true)
    }
    const closeAlert = () => {
        setShowAlert(false)
    }
    const [alertMessage, setAlertMessage] = useState("")

    const [incomingTransactions, setIncomingTransactions] = useState([])
    const [outgoingTransactions, setOutgoingTransactions] = useState([])
    const [allTransactions, setAllTransactions] = useState([])
    const [allFilteredTransactions, setAllFilteredTransactions] = useState([])
    const [allSortedTransactions, setAllSortedTransactions] = useState([])
    const [filterArticles, setFilterArticles] = useState(false)
    const toggleFilterArticles = () => {
        setFilterArticles(!filterArticles)
    }

    const { sortTransactions } = useSortTransactions(allTransactions, setAllSortedTransactions)
    const { expandRow, getIsExpandedRow } = useExpandRows()
    const { filterTransactionsBySearchInput, filterTransactionsByDateInput, filterTransactionsBySelectInput, filterTransactionsAndArticlesBySearchInput } = useFilterTransactions()
    const { dateSelect, handleDatePickerCallback, handleClearFilter } = useDateFilter()
    const [statusSelect, handleStatusSelectChange] = useSelectFilter()
    const { searchInput, handleSearchInput } = useSearchFilter()

    const [articleDataReady, setArticleDataToReady] = useState(false)

    useEffect(() => {
        setTaskName("Die eingehende Transaktionen werden geladen")
        FetchReadIncomingTransactions(setIncomingTransactions, openAlert, setArticleDataToReady, undefined, "TransactionArchive", true)

        setTaskName("Die ausgehende Transaktionen werden geladen")
        FetchReadOutgoingTransactions(setOutgoingTransactions, openAlert, setArticleDataToReady, undefined, "TransactionArchive", true)
    }, []);

    const reload = () => {
        setTaskName("Die eingehende Transaktionen werden geladen")
        FetchReadIncomingTransactions(setIncomingTransactions, openAlert, setArticleDataToReady, undefined, "TransactionArchive", true)

        setTaskName("Die ausgehende Transaktionen werden geladen")
        FetchReadOutgoingTransactions(setOutgoingTransactions, openAlert, setArticleDataToReady, undefined, "TransactionArchive", true)
    }

    useEffect(() => {
        setAllTransactions([...incomingTransactions.filter(item => item.State == "Confirmed" && item.Type != "NewArrivals"), ...outgoingTransactions.filter(item =>
            item.State == "Confirmed" && item.Type == "Delivery")])
        setArticleDataToReady(true)
    }, [incomingTransactions, outgoingTransactions])

    useEffect(() => {
        setAllFilteredTransactions([...allTransactions])
        setAllSortedTransactions([...allTransactions])
    }, [allTransactions])

    const takeSortedTransactions = () => {
        //Maybe this shouldn't be done in general, as there should be another option to deep clone an object!
        let deepCopy = JSON.parse(JSON.stringify(allSortedTransactions))
        return deepCopy
    }

    useEffect(() => {
        let filteredTransactions = filterArticles ? filterTransactionsAndArticlesBySearchInput(takeSortedTransactions(), searchInput) : filterTransactionsBySearchInput(allSortedTransactions, searchInput)
        filteredTransactions = filterTransactionsByDateInput(filteredTransactions, dateSelect)
        filteredTransactions = filterTransactionsBySelectInput(filteredTransactions, statusSelect)

        setAllFilteredTransactions(filteredTransactions)
    }, [searchInput, dateSelect, statusSelect, allSortedTransactions, filterArticles])

    const [newCorrections, setNewCorrections] = useState([])
    const [correctionAmounts, setCorrectionAmounts] = useState([])

    const [corrections, setCorrections] = useState([])
    const openCorrectionLine = (transactionSysId, articleSysId) => {
        const uniqueCorrectionId = transactionSysId + "__" + articleSysId
        if (corrections.includes(uniqueCorrectionId)) {
            setCorrections(corrections.filter(item => item !== uniqueCorrectionId))
            correctionRefs.current = correctionRefs.current.filter(item => item.value !== null)
        } else {
            const newCorrections = [...corrections]
            newCorrections.push(uniqueCorrectionId)
            setCorrections(newCorrections)
        }
    }

    let correctionRefs = useRef([]);

    const getCorrectionInputFields = (transactionSysId, articleSysId, sizeEntries) => {
        return (
            <>
                {sizeEntries.map(entry =>
                    <td className="numberColumn">
                        <Form>
                            <Form.Control as="input" defaultValue="0" type="number" size="sm" ref={node => correctionRefs.current[transactionSysId + "__" + articleSysId + "__" + entry.SizeValue] = node} />
                        </Form>
                    </td>)
                }
            </>
        )
    }

    const getNewCorrectionValues = (articleSizes) => {
        return (
            <>
                {articleSizes.map(entry =>
                    entry.NewCorrectionAmount !== undefined ?
                        <td className="numberColumn">{(entry.NewCorrectionAmount > 0 ? "+" : "") + entry.NewCorrectionAmount}</td>
                        : null)
                }
            </>
        )
    }

    const [showConfirmationModal, setShowConfirmationModel] = useState(false)
    const [confirmTransactionSysId, setTransactionSysId] = useState("")
    const [confirmTransactionState, setTransactionState] = useState("")

    const [modalTitle, setModalTitle] = useState("")
    const [modalDescription, setModalDescription] = useState("")

    const handleCloseConfirmationModal = () => setShowConfirmationModel(false)

    const [taskName, setTaskName] = useState("TransactionArchive unbekannte Task")


    const getCsvFileName = (transactionSysId, date, deliveryTo) => {
        return (date.replace(".", "-") + "_Lieferarchiv")
    }

    const getCsvData = (articles, sizeCategories) => {
        let csvArrayData = []

        sizeCategories.forEach(x => {

            let csvData = []

            articles.sort((a, b) => a.DesignerName.localeCompare(b.DesignerName) || a.Name.localeCompare(b.Name))
                .filter(y => y.SizeCat === x).forEach(article => {

                    let object =
                    {
                        "Designername": article.DesignerName,
                        "Artikelnr. FAEX": article.ArticleIdFaex,
                        "Artikelnr. Designer": article.ArticleNumberDesigner,
                        "Artikelname": article.Name,
                        "Größenkategorie": x,
                        "Farbe": article.Colour,
                        "Vk-Preis": article.SalePrice,
                    }

                    article.Sizes.forEach(size => {
                        let key = size.SizeValue.toString() + " "
                        let value = size.Amount
                        let sizePair = { [key]: value }

                        object = { ...object, ...sizePair }
                    })

                    let numbers = article.Sizes.map(entry => parseInt(entry.Amount))
                    let total = 0
                    numbers.map(number => total = parseInt(total) + parseInt(number))
                    let totalPair = { "Total": total }
                    object = { ...object, ...totalPair }

                    csvData.push(object)
                }
                )
            csvArrayData.push(csvData)
        })
        return (csvArrayData)
    }

    const getTotalTotal = (articleTypes) => {
        let numbersTotal = 0
        articleTypes.forEach(x => {
            let numbers = x.Sizes.map(entry => parseInt(entry.Amount))
            let total = 0
            numbers.map(number => total = parseInt(total) + parseInt(number))

            numbersTotal += total
        })

        return numbersTotal
    }

    const handleApproveTransaction = () => {
        if (confirmTransactionSysId != "") {
            const stateChangeModel = {
                AbstractTransactionSysId: confirmTransactionSysId,
                OldState: confirmTransactionState,
                NewCorrections: incomingTransactions.filter(x => x.TransactionSysId == confirmTransactionSysId)[0].Articles
            };

            FetchApproveCorrection(stateChangeModel, handleCloseConfirmationModal, reload, openAlert)
        }
    }

    const [filterable, setFilterable] = useState(false)
    const setFilterbar = () => {
        setFilterable(!filterable)
    }

    const getStorageName = () => {
        let storageName = JSON.parse(sessionStorage.getItem("loginInformation")).StorageName
        return storageName
    }

    return (
        <div>
        <h1 className="tablet-center">Lieferarchiv</h1>
        <div className="flex-linebreak"></div>

            <div className="inline">
                <FormControl className="globalSearch searchBar" as="input" defaultValue={searchInput} placeholder="Suche..." onChange={handleSearchInput}></FormControl>
                <Button variant="light" className="filter-button form-control" onClick={toggleFilterArticles}>{filterArticles ? "Lieferscheine filtern" : "Artikel filtern"}</Button>
            </div>
            <div className="tablet-transactions">
                <Table className="table-sm table-striped-immediate">
                    <thead className="sticky-table-header">
                        <th></th>
                        <th className="mainColumn">Lieferung von
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'SourceName')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Lieferung an
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'TargetName')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Erstellungsdatum
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'CreationDate')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Lieferscheinnr.
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'TransactionNumber')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Lieferdatum
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'TransactionDate')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Status
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'State')}>&#8593; &#8595;</a>
                        </th>
                        <th className="mainColumn">Bemerkung
                            <a href="" className="sort-link" onClick={(e) => sortTransactions(e, 'Remark')}>&#8593; &#8595;</a>
                        </th>
                        <th className="filterIndicator" onClick={setFilterbar}>&#8711; Filter</th>
                    </thead>
                    {filterable ? <thead>
                        <th></th><th></th><th></th>
                        <th>{DateSelect(handleDatePickerCallback, handleClearFilter, dateSelect)}</th>
                        <th></th>
                        <th></th>
                        <th>{StateSelect([...new Set(allTransactions.map(x => EnumValueTranslations(x.State)))], handleStatusSelectChange, statusSelect)}</th>
                        <th></th>
                        <th></th>
                    </thead> : null}
                    <tbody>
                        {allFilteredTransactions.map((transaction) =>
                            <>
                                <tr className="salesboutique-mainrow" onClick={(e) => expandRow(e, transaction.TransactionSysId)} aria-expanded={getIsExpandedRow(transaction.TransactionSysId)} aria-controls={transaction.TransactionSysId}>
                                    {getIsExpandedRow(transaction.TransactionSysId) ? <td className="expandIndicator">&#8722;</td> : <td className="expandIndicator">&#43;</td>}
                                    <td>{transaction.SourceName !== "" ? transaction.SourceName : getStorageName()}</td>
                                    <td>{transaction.TargetName !== "" ? transaction.TargetName : getStorageName()}</td>
                                    <td>{transaction.CreationDate}</td>
                                    <td>{transaction.TransactionNumber}</td>
                                    <td>{transaction.TransactionDate}</td>
                                    <td className={getColourClassStatus(transaction.State)}>{EnumValueTranslations(transaction.State)}</td>
                                    <OverlayTrigger trigger={["hover", "click"]} placement="top" overlay={DescriptionTooltip(transaction.Remark)}>
                                        <td className="remark-td">{transaction.Remark}</td>
                                    </OverlayTrigger>
                                    <td></td>
                                </tr>

                                <Collapse in={getIsExpandedRow(transaction.TransactionSysId)} timeout={30}>
                                    <td colSpan="6" className="td-nomargin">
                                        <div id={transaction.TransactionSysId} className="salesBoutique-child-div">
                                            {[...new Set(transaction.Articles.map(article => article.SizeCat))].map(sizeCat =>
                                                <>
                                                    <thead className="sticky-table-header">
                                                        <tr>
                                                            <th className="imageColumn"></th>
                                                            <th>Designername</th>
                                                            <th>Artikelnr. FAEX</th>
                                                            <th>Artikelnr. Designer</th>
                                                            <th>{sizeCat}</th>
                                                            <th>Farbe</th>
                                                            <th>Vk-Preis</th>
                                                            {getSizeEntries(transaction.Articles.find(x => x.SizeCat === sizeCat).Sizes)}
                                                            <th className="sizeColumn">Total</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {transaction.Articles.sort((a, b) => a.DesignerName.localeCompare(b.DesignerName) || a.Name.localeCompare(b.Name))
                                                            .filter(x => x.SizeCat === sizeCat).map(article =>
                                                                <>
                                                                    <tr>
                                                                        <td className="imageColumn"></td>
                                                                        <td>{article.DesignerName}</td>
                                                                        <td>{article.ArticleIdFaex}</td>
                                                                        <td>{article.ArticleNumberDesigner}</td>
                                                                        <td>{article.Name}</td>
                                                                        <td>{article.Colour}</td>
                                                                        <td className="numberColumn">{parseFloat(article.SalePrice).toFixed(2).replace('.', ',') + "€"}</td>
                                                                        {getSizeNumbers(article.Sizes)}
                                                                        {getTotal(article.Sizes)}
                                                                    </tr>

                                                                    {article.CorrectedArticles == true ?
                                                                        <tr className={correctionColor(transaction.State)}>
                                                                            <td></td>
                                                                            <td>Korrektur:</td>
                                                                            <td></td>
                                                                            {getCorrectionNumbers(article.Sizes)}
                                                                        </tr>
                                                                        : null}

                                                                    {newCorrections.includes(transaction.TransactionSysId + "__" + article.ArticleTypeSysId) == true ?
                                                                        <tr className="correction-corrected">
                                                                            <td className="new-correction">Neue Korrektur:</td>
                                                                            <td />
                                                                            <td />
                                                                            {getNewCorrectionValues(article.Sizes)}

                                                                        </tr>
                                                                        : null}
                                                                </>
                                                        )}

                                                        <tr className="stockReport-row">
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>Summe: </td>
                                                            <td>{getTotalTotal(transaction.Articles)}</td>
                                                        </tr>

                                                    </tbody>
                                                </>
                                            )}
                                        </div>

                                        <tr>
                                            <td></td>
                                            <td><ExportCSV className="searchBar" disabled={false} csvData={getCsvData(transaction.Articles, [...new Set(transaction.Articles.map(article => article.SizeCat))])} fileName={getCsvFileName(transaction.TransactionSysId, transaction.CreationDate, transaction.SourceOrTargetName)} isTransaction={true} /></td>
                                        </tr>

                                    </td>
                                </Collapse>
                            </>
                        )}
                    </tbody>
                </Table>
            </div>

            <ModalComponent handleShow={showConfirmationModal} handleClose={handleCloseConfirmationModal} handleSubmit={handleApproveTransaction}
                reload={reload} modalTitle={modalTitle} modalBody={modalDescription} />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} message={alertMessage} />
            <LoadingSpinner task={taskName} area={"TransactionArchive"} />

        </div>
    );
}

export default (TransactionArchive)
